/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-03 19:42:41
 * Description :
 * -----
 * Last Modified: 2024-12-12 16:47:04
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */


import {lazy} from 'react';
import { RouterConfig } from '../../types';

const configurationRouterConfig: RouterConfig[] = [
    {
        key: 'Configuration',
        title: 'menuTitleConfiguration',
        icon: 'ConfigMenuSVG',
        subs: [
            {
                key: 'Meter Type Mgnt',
                title: 'menuTitleMeterRegisterMgnt',
                route: '/home/configuration/meterRegisterMgnt',
                component: lazy(() => import('src/pages/configuration/meterRegisterMgnt')),
            },
            {
                key: 'System Parameters',
                title: 'menuTitleSystemParameters',
                route: '/home/configuration/systemParameters',
                component: lazy(() => import('src/pages/configuration/systemParameters')),
            },
            {
                key: 'Config DCU Archive',
                title: 'menuTitleConfigDcuArchive',
                route: '/home/configuration/configDcuArchive',
                component: lazy(() => import('src/pages/configuration/configDcuArchive')),
            },
            {
                key: 'DCU Schedule',
                title: 'menuTitleDcuSchedule',
                route: '/home/configuration/dcuSchedule',
                component: lazy(() => import('src/pages/configuration/dcuSchedule')),
            },
            {
                key: 'Command Config',
                title: 'menuTitleCommandConfig',
                route: '/home/configuration/commandConfig',
                component: lazy(() => import('src/pages/configuration/commandConfig')),
            },
            {
                key: 'Meter Type Parameters',
                title: 'menuTitleMeterTypeParameters',
                route: '/home/configuration/meterTypeParameters',
                component: lazy(() => import('src/pages/configuration/meterTypeParameters')),
            },
            {
                key: 'NTP Config',
                title: 'menuTitleNTPConfig',
                route: '/home/configuration/NTPConfig',
                component: lazy(() => import('src/pages/configuration/NTPConfig')),
            },
            {
                key: 'Configure Load Profile',
                title: 'menuTitleConfigLoadProfile',
                route: '/home/configuration/configLoadProfile',
                component: lazy(() => import('src/pages/configuration/configLoadProfile')),
            },
            {
                key: 'Activity Calender',
                title: 'menuTitleActivityCalender',
                route: '/home/configuration/activityCalender',
                component: lazy(() => import('src/pages/configuration/activityCalender')),
            },
            {
                key: 'Line Loss Analysis',
                title: 'menuTitleLineLossAnalysis',
                route: '/home/configuration/lineLossAnalysis',
                component: lazy(() => import('src/pages/configuration/lineLossAnalysis')),
            },
            {
                key: 'Operator Online Mgnt',
                title: 'menuTitleOpreatorOnlineMgnt',
                route: '/home/configuration/opreatorOnlineMgnt',
                component: lazy(() => import('src/pages/configuration/opreatorOnlineMgnt')),
            },
            {
                key: 'System Parameters Mgnt',
                title: 'menuTitleSystemParametersMgnt',
                route: '/home/configuration/systemParametersMgnt',
                component: lazy(() => import('src/pages/configuration/systemParametersMgnt')),
            },
            {
                key: 'Alarm Info Config',
                title: 'menuTitleAlarmInfoConfig',
                route: '/home/configuration/alarmInfoConfig',
                component: lazy(() => import('src/pages/configuration/alarmInfoConfig')),
            },
            {
                key: 'Event Info Config',
                title: 'menuTitleEventInfoConfig',
                route: '/home/configuration/eventInfoConfig',
                component: lazy(() => import('src/pages/configuration/eventInfoConfig')),
            },
            {
                key: 'Special Days',
                title: 'menuTitleSpecialDays',
                route: '/home/configuration/specialDays',
                component: lazy(() => import('src/pages/configuration/specialDays')),
            },
            {
                key: 'Dcu Type Mgnt',
                title: 'menuTitleDcuTypeMgnt',
                route: '/home/configuration/dcuTypeMgnt',
                component: lazy(() => import('src/pages/configuration/dcuTypeMgnt')),
            },
            {
                key: 'Remote Command Mgnt',
                title: 'menuTitleRemoteCommandMgnt',
                route: '/home/configuration/remoteCommandMgnt',
                component: lazy(() => import('src/pages/configuration/remoteCommandMgnt')),
            },
            {
                key: 'VEE Config',
                title: 'menuFrozenDataValidConfig',
                route: '/home/configuration/frozenDataValidConfig',
                component: lazy(() => import('src/pages/configuration/frozenDataConfig')),
            },
            {
                key: 'Auto Register Config',
                title: 'menuTitleAutoRegisterConfig',
                route: '/home/configuration/autoRegisterConfig',
                component: lazy(() => import('src/pages/configuration/autoRegisterConfig')),
            },
        ],
    },
];

export default configurationRouterConfig;
